import React, { type ReactNode } from 'react'

import Header from './Header'

export default function SurveyLayout({ children }: { children: ReactNode }) {
  return <>{children}</>
}

function Section({ children, fullHeight = false }: { children: ReactNode; fullHeight?: boolean }) {
  return <section style={{ height: fullHeight ? '100dvh' : 'calc(100% - 80px)' }}>{children}</section>
}

SurveyLayout.Header = Header
SurveyLayout.Section = Section
